// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_ff","advertDetailService__price":"c-o_fg"};